import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MODAL_AGENT_DETAIL, MODAL_AGENT_EXECUTOR_DETAIL, MODAL_AGENT_TRIGGER_WARNING, MODAL_UPGRADE_LICENSE, MODAL_UPGRADE_LICENSE_CLOUD_AGENTS } from 'store/modals/modals';
import ReduxModal from 'Common/Components/ReduxModal';
import UpgradeLicense from 'Common/Components/UpgradeLicense';
import { Wrapper, TopWrapper } from './styled';
import ActionBar from './components/ActionBar';
import Tabs from './components/Tabs';
import { resetState, setPageUserAgents } from 'store/Agents/actions';
import { selectShowGridView } from 'store/Filters/selectors';
import { setShowGridView } from 'store/Filters/actions';
import selectModal from 'store/modals/selectors';
import { AGENTS, RUN_STATUS_LOG } from './components/Tabs/constants';
import VisualModeButton from './components/VisualModeButton';
import Content from './components/Content';
import upgradeLicenseImage from 'Images/workspaces-license.png';
import FFCloudAgents from 'Images/ff_cloud_agents.png';
import { ACTIONS } from 'tracking/GA/constants';
import { closeModal } from 'store/modals/actions';
import { selectAgentEntity } from 'store/Agents/selectors';
import { RUNNERS_ENTITY, AGENTS_EXECUTION_ENTITY } from 'store/Agents/reducer';

// No Security Scanners entry: that tab is an upgrade teaser in community, it never gets selected.
const ENTITY_TAB_MAP = {
  [RUNNERS_ENTITY]: AGENTS,
  [AGENTS_EXECUTION_ENTITY]: RUN_STATUS_LOG
};

const Agents = () => {
  const dispatch = useDispatch();
  const persistedAgentEntity = useSelector(selectAgentEntity);
  const [selectedTab, setSelectedTab] = useState(() => ENTITY_TAB_MAP[persistedAgentEntity] || AGENTS);

  const entity = 'agents';
  const showGridView = useSelector((state) => selectShowGridView(entity, state));

  const showAgentDetail = useSelector((state) => selectModal(state, MODAL_AGENT_DETAIL));
  const showTriggerWarning = useSelector((state) => selectModal(state, MODAL_AGENT_TRIGGER_WARNING));

  const toggleView = () => {
    dispatch(setShowGridView(entity, !showGridView));
    dispatch(setPageUserAgents(1));
  };

  useEffect(() => () => {
    dispatch(resetState());
  }, [dispatch]);

  useEffect(() => () => {
    dispatch(closeModal(MODAL_AGENT_DETAIL));
    dispatch(closeModal(MODAL_AGENT_EXECUTOR_DETAIL));
  }, [dispatch, selectedTab]);

  return (
    <>
      <Wrapper>
        <ReduxModal id={ MODAL_UPGRADE_LICENSE }>
          <UpgradeLicense id={ MODAL_UPGRADE_LICENSE } image={ upgradeLicenseImage } descriptionIntlId="upgradeLicense.workspace.description" trackingShow={ ACTIONS.showAgents } trackingClick={ ACTIONS.clickAgents } />
        </ReduxModal>
        <ReduxModal id={ MODAL_UPGRADE_LICENSE_CLOUD_AGENTS }>
          <UpgradeLicense id={ MODAL_UPGRADE_LICENSE_CLOUD_AGENTS } image={ FFCloudAgents } descriptionIntlId="upgradeLicense.sidebar.cloudAgents.description" />
        </ReduxModal>
        <TopWrapper>
            <Tabs selectedTab={ selectedTab } setSelectedTab={ setSelectedTab } />
            <VisualModeButton seletedTab={ selectedTab } showGridView={ showGridView } toggleView={ toggleView } />
        </TopWrapper>
        <ActionBar selectedTab={ selectedTab } showCloudAgents={ false } />
        <Content showGridView={ showGridView } selectedTab={ selectedTab } showAgentDetail={ showAgentDetail } showTriggerWarning={ showTriggerWarning } />
      </Wrapper>
    </>
  );
};

export default Agents;
